import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import Popover from "@material-ui/core/Popover";
import withStyles from "@material-ui/core/styles/withStyles";
import ToolTip from "@material-ui/core/Tooltip";
import helpIcon from "Assets/Icons/Help/help-16px.svg";
import checklistglyph from "Assets/newicons/app/checklist/glyph/checklist-glyph-16px.svg";
import checklistoutlined from "Assets/newicons/app/checklist/outline/checklist-outline-16px.svg";
import okroutlined from "Assets/newicons/app/okr/outilne/okr-outline-16px.svg";
import Performreviewoutlined from "Assets/newicons/app/okr/outilne/perform-outline-16px.svg";
import get from "lodash/get";
import moment from "moment";
import { withSnackbar } from "notistack";
import publicIp from "public-ip";
import React from "react";
import { IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import {
  LogMeOut,
  updateAuthentication,
} from "../../Actions/AuthenticationAction";
import { instance } from "../../Actions/AxiosInstance";
import {
  CommonReducerAction,
  GetFeature,
  SetAllApps,
  SetClickedBreadCrum,
  SetDrawerID,
  SetMenuData,
  SetMenuList,
  SetOpenLeftDrawer,
  SetSelection,
} from "../../Actions/commonAction";
import {
  removeSaveProgress,
  setSaveProgress,
} from "../../Actions/SaveProgressAction";
import { updateSubscriptionInfo } from "../../Actions/SubscriptionInfo";
import InviteEmoloyeeIcon from "../../Assets/Icons/Add-user/add-user-16px.svg";
import DirectoryIcon from "../../Assets/Icons/Directory/directory-16px.svg";
import LiveDataIcon from "../../Assets/Icons/Live-data/live-data-16px.svg";
import PlannerIcon from "../../Assets/Icons/Planner/planner-16px.svg";
import RoboIcon from "../../Assets/Icons/Report-robo/report-robo-16px.svg";
import attendanceglyph from "../../Assets/newicons/app/attendance/glyph/attendance-glyph-16px.svg";
import attendanceoutlined from "../../Assets/newicons/app/attendance/outline/attendance-outline-16px.svg";
import driveglyph from "../../Assets/newicons/app/drive/glyph/drive-glyph-16px.svg";
import driveoutlined from "../../Assets/newicons/app/drive/outline/drive-outline-16px.svg";
import expenseglyph from "../../Assets/newicons/app/expense/glyph/expense-glyph-16px.svg";
import expenseoutlined from "../../Assets/newicons/app/expense/outline/expense-outline-16px.svg";
import holidayglyph from "../../Assets/newicons/app/holiday/glyph/holiday-glyph-16px.svg";
import holidayoutlined from "../../Assets/newicons/app/holiday/outline/holiday-outline-16px.svg";
import leavesglyph from "../../Assets/newicons/app/leaves/glyph/leaves-glyph-16px.svg";
import leavesoutlined from "../../Assets/newicons/app/leaves/outline/leaves-outline-16px.svg";
import letterboxglyph from "../../Assets/newicons/app/letterbox/glyph/letterbox-glyph-16px.svg";
import letterboxoutlined from "../../Assets/newicons/app/letterbox/outline/letterbox-outline-16px.svg";
import homeglyph from "../../Assets/newicons/app/my-desk/glyph/my-desk-glyph-16px.svg";
import homeoutlined from "../../Assets/newicons/app/my-desk/outline/my-desk-outline-16px.svg";
import policyglyph from "../../Assets/newicons/document/policy/glyph/policy-glyph-16px.svg";
import policyoutlined from "../../Assets/newicons/document/policy/outline/policy-outline-16px.svg";
import profileglyph from "../../Assets/newicons/user/user/glyph/user-glyph-16px.svg";
import profileoutlined from "../../Assets/newicons/user/user/outline/user-outline-16px.svg";
// import policyoutlined from "../../Assets/newicons/document/policy/outline/policy-outline-16px.svg";
import payrollglyph from "../../Assets/Svg/payroll-glyph-16-px.svg";
import reportee from "../../Assets/Svg/reportee-hierarchy-outline-16px.svg";
import { FEATUREKEYS, NAVIGATION } from "../../Constants";
import { getFormattedMenuList } from "../../Utils";
import "./Navigation.css";

const drawerWidth = 250;

const styles = (theme) => ({
  root: {
    position: "relative",
    background: "#f7f8f8",
  },
  menuBar: {
    backgroundColor: theme.palette.background.default,
    padding: 0,
    width: 64,
  },
  imgBox: {
    justifyContent: "center",
    alignItems: "center",
    float: "left",
  },
  primary: {},
  icon: {},
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 20,
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    backgroundColor: "#f7f8f8",
    borderRight: 0,
  },
  drawerConfig: {
    width: drawerWidth,
    flexShrink: 0,
    marginRight: -50,
    // backgroundColor: theme.palette.background.default
    backgroundColor: "#444444",
    borderRight: 0,
    position: "relative",
  },
  drawerOpenAr: {
    left: "237px",
    transition: theme.transitions.create("left", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerCloseAr: {
    left: "52px",
    transition: theme.transitions.create("left", {
      easing: theme.transitions.easing.sharp,
      duration: "200ms",
      position: "relative",
    }),
  },
  drawerOpen: {
    // width: drawerWidth,
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    backgroundColor: "#f7f8f8",
    borderRight: 0,
    // position: "relative",
    // height: "100vh",
  },
  drawerOpenConfig: {
    width: drawerWidth,
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    backgroundColor: "#444444",
    borderRight: 0,
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: "200ms",
    }),
    overflowX: "hidden",
    width: 64,
    backgroundColor: "#f7f8f8",
    borderRight: 0,
    position: "relative",
    height: "100vh",
  },
  drawerCloseConfig: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: "200ms",
    }),
    overflowX: "hidden",
    width: theme.spacing.unit * 7 + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing.unit * 9 + 1,
    },
    backgroundColor: "#444444",
    borderRight: 0,
  },

  drawerPaper: {
    width: drawerWidth,
    paddingLeft: 64,
    backgroundColor: "#f7f8f8",
    position: "relative",
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: "0 8px",
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: "200ms",
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
  expand: {
    transform: "rotate(0deg)",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
    marginLeft: "auto",
    [theme.breakpoints.up("sm")]: {
      marginRight: -8,
    },
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
  slider: {
    padding: "42px 20px",
  },
  expansionPanel: {
    boxShadow: "0px 0px 0px",
    margin: 0,
    borderTopWidth: 0.5,
    borderTopColor: "#dcdcdc",
    "&$expanded": {
      margin: 0,
      borderTopWidth: 0.5,
      borderTopColor: "#dcdcdc",
      minHeight: 40,
      marginTop: 0,
      marginBottom: 0,
    },
    backgroundColor: "transparent",
  },
  navMenuSummary: {
    padding: 0,
    height: 46,
    minHeight: 46,
    marginBottom: 0,
    "&$expanded": {
      minHeight: 46,
      marginTop: 0,
      marginBottom: 0,
    },
  },
  navMenuh40: {
    height: 40,
    minHeight: 40,
    "&$expanded": {
      minHeight: 40,
    },
  },
  navMenuh0: {
    height: 0,
    minHeight: 0,
    "&$expanded": {
      minHeight: 0,
    },
  },
  dmroot: {
    boxShadow: "0px 0px 0px",
    backgroundColor: "transparent",
    margin: 0,
    padding: "8px 0",
    borderBottomLeftRadius: "0px !important",
    borderBottomRightRadius: "0px !important",
  },
  navFooter: {
    position: "fixed",
    bottom: 0,
    zIndex: 9999,
    width: 218,
    height: 110,
    marginTop: 30,
    display: "flex",
    flexDirection: "column",
  },
  navFooterCollapsed: {
    position: "fixed",
    bottom: 0,
    zIndex: 9999,
    width: 64,
    height: 110,
    marginTop: 30,
    display: "flex",
    flexDirection: "column",
  },
  h3: {
    margin: 0,
    display: "flex",
    padding: "4px 0px",
    height: 32,
    minHeight: 32,
    overflow: "visible",
    width: "100%",
    color: "#fff",
  },
  h3Div: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
  },
  h2: {
    position: "relative",
    listStyleType: "none",
    margin: 0,
    padding: "4px 0",
    width: 214,
  },
  h3Icon: {
    width: "1em",
    height: "1em",
    display: "inline-block",
    flexShrink: 0,
    margin: 4,
    // marginLeft: 8,
    fontSize: "24px",
  },
  configButton: {
    left: "12px",
    fontWeight: "bold",
    width: "106px",
    color: "#fff",
    bottom: "77px",
    position: "absolute",
    fontSize: "14px",
    marginRight: "12px",
    // position: "absolute",
    // bottom: 68,
    // // right: 0,
    // left: 8,
    // width: 106,
    // // float: "right",
    // marginRight: 12,
    // fontSize: 12,
    // // backgroundColor: "#166ab3",
    // color: "#166ab3"
  },
  toolbar1: {
    position: "fixed",
    top: 16,
    width: 24,
    height: 24,
    zIndex: 9999,
    backgroundColor: "#fff",
    color: "#011833",
    borderRadius: "50%",
    boxShadow: "0px 0px 3px #011833",
    transition: "left .2s ease",
    // left: isDrawerOpen ? 229 : 62,
    // transform: isDrawerOpen ? "scale(1,1)" : "scale(-1,1)"
  },
  colorSwitchBase: {
    color: "grey",
    "&$colorChecked": {
      color: "grey",
      "& + $colorBar": {
        backgroundColor: "grey",
      },
    },
  },
  colorBar: {},
  colorChecked: {},
  iOSSwitchBase: {
    "&$iOSChecked": {
      color: "white",
      "& + $iOSBar": {
        backgroundColor: "#52d869",
      },
    },
    transition: theme.transitions.create("transform", {
      duration: "100ms",
      easing: "50ms",
    }),
  },
  iOSChecked: {
    transform: "translateX(15px)",
    "& + $iOSBar": {
      opacity: 1,
      border: "none",
    },
  },
  iOSBar: {
    borderRadius: 13,
    width: 40,
    height: 20,
    marginTop: -11,
    marginLeft: -20,
    border: "solid 1px",
    borderColor: "transparent",
    backgroundColor: "grey",
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
  iOSIcon: {
    width: 24,
    height: 24,
    marginLeft: -2,
    marginTop: -2,
  },
  iOSIconChecked: {
    // boxShadow: theme.shadows[1],
    marginLeft: 0,
  },
});
class LeftNavigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      navPopper: false,
      arrowRef: null,
      nav_anchor: null,
      playsound: false,
      addClass: false,
      show: false,
      anchorEl: null,
      redirect: false,
      changePassword: false,
      expanded: false,
      vacid: 1,
      flags: {
        dashboardFlag: false,
        subscriptionownerFlag: false,
        payment: false,
      },
      menuList: [],
      menuListTemp: [],
      isView: true,
      isConfig: false,
      isAction: false,
      SubscriptionData: {},
      imagepath: "",
      openParentMenuId: "",
      openParentItem: {},
      sliderValue: 0,
      showConfigOptions: false,
      selectedDrawerOption: "",
      isStopped: false,
      isPaused: false,
      open: true,
      ProfileBasicInfo: this.props.AuthenticationAction.login,
      newmenulist: [],
      configRoutesMissing: true,
      clockintime: [],
      showtime: null,
    };
    this.showpopper = this.showpopper.bind(this);
    this.handleref = this.handleref.bind(this);
    this.updateDrawer = this.updateDrawer.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.getClockIn = this.getClockIn.bind(this);
  }

  componentDidMount() {
    const { features } = this.props.AuthenticationAction.login;
    const [_, newmenu = [], newmenulisticons = []] = getFormattedMenuList(
      NAVIGATION.normal,
      features,
    );
    this.getClockIn();
    const [isConfigAvailable] = getFormattedMenuList(
      NAVIGATION.config,
      features,
    );
    this.setState({
      newmenulist: newmenu,
      configRoutesMissing: !isConfigAvailable,
    });
  }

  componentWillReceiveProps(nextprops) {
    const nextproptime =
      nextprops.clockin &&
      nextprops.clockin.clockin &&
      nextprops.clockin.clockin.slice(-1);
    const nexttime =
      this.props.clockin &&
      this.props.clockin.clockin &&
      this.props.clockin.clockin.slice(-1);
    if (
      (nextproptime &&
        nextproptime[0] &&
        nextproptime[0].transactiondatetime) !=
      (nexttime && nexttime[0] && nexttime[0].transactiondatetime)
    ) {
      this.setState({
        clockintime: nextprops.clockin.clockin,
      });
    }
  }

  getClockIn() {
    instance.get("attendance/empcurrentshift").then((resp) => {
      const shiftdate =
        (resp.data.result[0] &&
          resp.data.result[0].currentshift[0] &&
          resp.data.result[0].currentshift[0].shiftdate) ||
        new Date();
      instance
        .post("attendance/allpunchlogbyempid", { shiftdate })
        .then((resp) => {
          //  this.props.removeSaveProgress();
          this.setState({ clockintime: resp.data.result });
        })
        .catch((error) => {
          //  this.props.removeSaveProgress();
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    });
  }

  initwebpunch = async () => {
    const { issaveinprogress } = this.props;
    if (!issaveinprogress) {
      const ip = await publicIp.v4();

      this.props.setSaveProgress(true);
      instance
        .get(`attendance/initwebpunch/${ip}`)
        .then(async (result) => {
          this.props.removeSaveProgress();
          this.setState({
            showtime: get(result.data, "result[0].transactiondatetime", ""),
          });
          try {
            const cdata = await instance.post("attendance/allpunchlogbyempid", {
              shiftdate: new Date(),
            });

            this.setState({ clockintime: cdata.data.result });
          } catch (e) {
            // this.props.removeSaveProgress();
          }
          this.props.enqueueSnackbar("Attendance punched successfully!", {
            variant: "success",
          });
        })
        .catch((error) => {
          this.props.removeSaveProgress();
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  };

  handleref(element) {
    this.setState({ arrowRef: element });
  }

  handleClose() {
    this.setState({ navPopper: false });
  }

  updateDrawer(key) {
    this.props.SetOpenLeftDrawer(true);
    this.props.SetAllApps(false);
    this.props.SetDrawerID(key);
    this.setState({
      navPopper: false,
    });
  }

  showpopper(event) {
    this.setState({
      navPopper: !this.state.navPopper,
      nav_anchor: event.currentTarget,
    });
  }

  route = (route) => {
    this.props.history.replace(route);
  };

  render() {
    const { classes } = this.props;
    const { anchorEl, configRoutesMissing, clockintime } = this.state;

    const isDrawerOpen = get(
      this.props,
      "selectionReducer.openLeftDrawer",
      false,
    );

    const isConfigMode = this.props.selectionReducer.appMode === "config";
    // classes

    const navListHide = isDrawerOpen ? "nav-list-show" : "nav-list-hide";
    const navFooter = isDrawerOpen ? "width218" : "width64";
    const navFooterList = isDrawerOpen
      ? "nav-footer-list-horizontal"
      : "nav-footer-list-vertical";
    const hideElement = isDrawerOpen ? "element-show" : "element-hide";
    let plannersubfeature = [];
    let livedatasubfeature = [];
    plannersubfeature = this.props.AuthenticationAction.login.features.filter(
      (feature) =>
        feature.parentmenuid == FEATUREKEYS.planner && !feature.isconfigmode,
    );
    livedatasubfeature = this.props.AuthenticationAction.login.features.filter(
      (feature) =>
        feature.parentmenuid == FEATUREKEYS.livedata && !feature.isconfigmode,
    );
    const reportrobo = this.props.AuthenticationAction.login.features.find(
      (feature) =>
        feature.featureid == FEATUREKEYS.reportRobo && !feature.isconfigmode,
    );
    const operations = this.props.AuthenticationAction.login.features.find(
      (feature) =>
        feature.featureid == FEATUREKEYS.operations && !feature.isconfigmode,
    );
    const inviteEmployee = this.props.AuthenticationAction.login.features.find(
      (feature) =>
        feature.featureid == FEATUREKEYS.inviteEmployee &&
        !feature.isconfigmode,
    );
    const requestCenter = this.props.AuthenticationAction.login.features.find(
      (feature) =>
        feature.featureid == FEATUREKEYS.requestCenter && !feature.isconfigmode,
    );
    const directory = this.props.AuthenticationAction.login.features.find(
      (feature) =>
        feature.featureid == FEATUREKEYS.directory && !feature.isconfigmode,
    );

    const reportingHierarchy =
      this.props.AuthenticationAction.login.features.find(
        (feature) =>
          feature.featureid == FEATUREKEYS.reportingHierarchy &&
          !feature.isconfigmode,
      );

    const showLeave =
      this.props.AuthenticationAction.login.features.filter(
        (feature) =>
          feature.parentmenuid == FEATUREKEYS.leave && !feature.isconfigmode,
      ).length !== 0;

    const showHoliday =
      this.props.AuthenticationAction.login.features.filter(
        (feature) =>
          feature.parentmenuid == FEATUREKEYS.leave && !feature.isconfigmode,
      ).length !== 0;

    const showAttendance =
      this.props.AuthenticationAction.login.features.filter(
        (feature) =>
          feature.parentmenuid == FEATUREKEYS.attendance &&
          !feature.isconfigmode,
      ).length !== 0;
    const alloff = !(
      !reportrobo &&
      plannersubfeature.length < 1 &&
      livedatasubfeature.length < 1
    );
    return (
      <IntlProvider locale="en" messages={null}>
        <div className="left-navbar">
          <div
            className="thin-scroll"
            style={{
              // height: "calc(100vh - 162px)",
              height:
                clockintime.length > 0
                  ? "calc(100vh - 224px)"
                  : "calc(100vh - 162px)",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <div className="nav-home">
              {
                <NavLink to="/desk">
                  <ListItem
                    button
                    className={
                      this.props.selectionReducer.selectedDrawerId ==
                      FEATUREKEYS.Home
                        ? " nav-list nav-list-item-row-active"
                        : "nav-list"
                    }
                    onClick={() => this.updateDrawer(FEATUREKEYS.Home)}
                  >
                    <ListItemIcon className="list-item-icon">
                      {this.props.selectionReducer.selectedDrawerId ==
                      FEATUREKEYS.Home ? (
                        <img src={homeglyph} />
                      ) : (
                        <img src={homeoutlined} />
                      )}
                    </ListItemIcon>
                    <ListItemText
                      className={
                        isDrawerOpen
                          ? "list-item-text display-block"
                          : "list-item-text hide-element"
                      }
                      primary="My Desk"
                    />
                  </ListItem>
                </NavLink>
              }
            </div>
            <div className={`${navListHide}`}>
              <List>
                {GetFeature("profile") && (
                  <NavLink to="/profile">
                    <ListItem
                      button
                      className={
                        this.props.selectionReducer.selectedDrawerId ==
                        FEATUREKEYS.profile
                          ? " nav-list nav-list-item-row-active profile"
                          : "nav-list profile"
                      }
                      onClick={() => this.updateDrawer(FEATUREKEYS.profile)}
                    >
                      <ListItemIcon className="list-item-icon">
                        {this.props.selectionReducer.selectedDrawerId ==
                        FEATUREKEYS.profile ? (
                          <img src={profileglyph} />
                        ) : (
                          <img src={profileoutlined} />
                        )}{" "}
                      </ListItemIcon>
                      <ListItemText
                        className="list-item-text"
                        primary={GetFeature("profile").featurename}
                      />
                    </ListItem>
                  </NavLink>
                )}
                {showAttendance &&
                  GetFeature("attendanceLogs") &&
                  GetFeature("attendance") && (
                    <NavLink to="/attendance">
                      <ListItem
                        button
                        className={
                          this.props.selectionReducer.selectedDrawerId ==
                          FEATUREKEYS.attendanceLogs
                            ? "nav-list nav-list-item-row-active"
                            : "nav-list"
                        }
                        onClick={() =>
                          this.updateDrawer(FEATUREKEYS.attendanceLogs)
                        }
                      >
                        <ListItemIcon className="list-item-icon">
                          {this.props.selectionReducer.selectedDrawerId ==
                          FEATUREKEYS.attendanceLogs ? (
                            <img src={attendanceglyph} />
                          ) : (
                            <img src={attendanceoutlined} />
                          )}
                        </ListItemIcon>
                        <ListItemText
                          className="list-item-text"
                          primary={GetFeature("attendance").featurename}
                        />
                      </ListItem>
                    </NavLink>
                  )}
                {showLeave &&
                  GetFeature("leaveBalanceAndHistory") &&
                  GetFeature("leave") && (
                    <NavLink to="/leave">
                      <ListItem
                        button
                        className={
                          this.props.selectionReducer.selectedDrawerId ==
                          FEATUREKEYS.leave
                            ? " nav-list nav-list-item-row-active"
                            : "nav-list"
                        }
                        onClick={() => this.updateDrawer(FEATUREKEYS.leave)}
                      >
                        <ListItemIcon className="list-item-icon">
                          {this.props.selectionReducer.selectedDrawerId ==
                          FEATUREKEYS.leave ? (
                            <img src={leavesglyph} />
                          ) : (
                            <img src={leavesoutlined} />
                          )}
                        </ListItemIcon>
                        <ListItemText
                          className="list-item-text"
                          primary={GetFeature("leave").featurename}
                        />
                      </ListItem>
                    </NavLink>
                  )}
                {showHoliday && GetFeature("holiday") && (
                  <NavLink to="/holiday">
                    <ListItem
                      button
                      className={
                        this.props.selectionReducer.selectedDrawerId ==
                        FEATUREKEYS.holiday
                          ? " nav-list nav-list-item-row-active"
                          : "nav-list"
                      }
                      onClick={() => this.updateDrawer(FEATUREKEYS.holiday)}
                    >
                      <ListItemIcon className="list-item-icon">
                        {this.props.selectionReducer.selectedDrawerId ==
                        FEATUREKEYS.holiday ? (
                          <img src={holidayglyph} />
                        ) : (
                          <img src={holidayoutlined} />
                        )}
                      </ListItemIcon>
                      <ListItemText
                        className="list-item-text"
                        primary={"Holiday"}
                      />
                    </ListItem>
                  </NavLink>
                )}

                {/* {Configs.MODE === "DEV" && GetFeature("checklist") && (
                  <NavLink to="/calendar">
                    <ListItem
                      button
                      className={
                        this.props.selectionReducer.selectedDrawerId ==
                        FEATUREKEYS.checklist
                          ? " nav-list nav-list-item-row-active"
                          : "nav-list"
                      }
                      onClick={() => this.updateDrawer(FEATUREKEYS.checklist)}
                    >
                      <ListItemIcon className="list-item-icon">
                        {this.props.selectionReducer.selectedDrawerId ==
                        FEATUREKEYS.checklist ? (
                          <img src={calendariconglyph} />
                        ) : (
                          <img src={calendariconoutline} />
                        )}
                      </ListItemIcon>
                      <ListItemText
                        className="list-item-text"
                        primary="Calendar"
                        // primary={GetFeature("policyCenter").featurename}
                      />
                    </ListItem>
                  </NavLink>
                )} */}

                {
                  // Configs.MODE === "DEV" &&
                  GetFeature("checklist") && (
                    // {true && (
                    <NavLink to="/checklist">
                      <ListItem
                        button
                        className={
                          this.props.selectionReducer.selectedDrawerId ==
                          FEATUREKEYS.checklist
                            ? " nav-list nav-list-item-row-active"
                            : "nav-list"
                        }
                        onClick={() => this.updateDrawer(FEATUREKEYS.checklist)}
                      >
                        <ListItemIcon className="list-item-icon">
                          {this.props.selectionReducer.selectedDrawerId ==
                          FEATUREKEYS.checklist ? (
                            <img src={checklistglyph} />
                          ) : (
                            <img src={checklistoutlined} />
                          )}
                        </ListItemIcon>
                        <ListItemText
                          className="list-item-text"
                          primary="Checklist"
                          // primary={GetFeature("policyCenter").featurename}
                        />
                      </ListItem>
                    </NavLink>
                  )
                }
                {GetFeature("employeePolicyCenter") && (
                  // {true && (
                  <NavLink to="/policycenter">
                    <ListItem
                      button
                      className={
                        this.props.selectionReducer.selectedDrawerId ==
                        FEATUREKEYS.employeePolicyCenter
                          ? " nav-list nav-list-item-row-active"
                          : "nav-list"
                      }
                      onClick={() =>
                        this.updateDrawer(FEATUREKEYS.employeePolicyCenter)
                      }
                    >
                      <ListItemIcon className="list-item-icon">
                        {this.props.selectionReducer.selectedDrawerId ==
                        FEATUREKEYS.employeePolicyCenter ? (
                          <img src={policyglyph} />
                        ) : (
                          <img src={policyoutlined} />
                        )}
                      </ListItemIcon>
                      <ListItemText
                        className="list-item-text"
                        primary="Policy center"
                        // primary={GetFeature("policyCenter").featurename}
                      />
                    </ListItem>
                  </NavLink>
                )}
                {GetFeature("employeeExpense") && (
                  <NavLink to="/expense">
                    <ListItem
                      button
                      className={
                        this.props.selectionReducer.selectedDrawerId ==
                        FEATUREKEYS.employeeExpense
                          ? " nav-list nav-list-item-row-active"
                          : "nav-list"
                      }
                      onClick={() =>
                        this.updateDrawer(FEATUREKEYS.employeeExpense)
                      }
                    >
                      <ListItemIcon className="list-item-icon">
                        {this.props.selectionReducer.selectedDrawerId ==
                        FEATUREKEYS.employeeExpense ? (
                          <img src={expenseglyph} />
                        ) : (
                          <img src={expenseoutlined} />
                        )}
                      </ListItemIcon>
                      <ListItemText
                        className="list-item-text"
                        primary="Expense"
                      />
                    </ListItem>
                  </NavLink>
                )}
                {GetFeature("drive") && GetFeature("myDrive") && (
                  <NavLink to="/drive">
                    <ListItem
                      button
                      className={
                        this.props.selectionReducer.selectedDrawerId ==
                        FEATUREKEYS.myDrive
                          ? " nav-list nav-list-item-row-active"
                          : "nav-list"
                      }
                      onClick={() => this.updateDrawer(FEATUREKEYS.myDrive)}
                    >
                      <ListItemIcon className="list-item-icon">
                        {this.props.selectionReducer.selectedDrawerId ==
                        FEATUREKEYS.myDrive ? (
                          <img src={driveglyph} />
                        ) : (
                          <img src={driveoutlined} />
                        )}
                      </ListItemIcon>
                      <ListItemText
                        className="list-item-text"
                        primary="Drive"
                      />
                    </ListItem>
                  </NavLink>
                )}
                {GetFeature("letterbox") && (
                  <NavLink to="/letter_box">
                    <ListItem
                      button
                      className={
                        this.props.selectionReducer.selectedDrawerId ==
                        FEATUREKEYS.letters
                          ? " nav-list nav-list-item-row-active"
                          : "nav-list"
                      }
                      onClick={() => this.updateDrawer(FEATUREKEYS.letters)}
                    >
                      <ListItemIcon className="list-item-icon">
                        {this.props.selectionReducer.selectedDrawerId ==
                        FEATUREKEYS.letters ? (
                          <img src={letterboxglyph} />
                        ) : (
                          <img src={letterboxoutlined} />
                        )}
                      </ListItemIcon>
                      <ListItemText
                        className="list-item-text"
                        primary="Letters"
                      />
                    </ListItem>
                  </NavLink>
                )}

                {/* {GetFeature("payroll") && ( */}
                {GetFeature("payroll") && (
                  <NavLink to="/payroll/package_proration">
                    <ListItem
                      button
                      className={
                        this.props.selectionReducer.selectedDrawerId ==
                        FEATUREKEYS.payroll
                          ? " nav-list nav-list-item-row-active"
                          : "nav-list"
                      }
                      onClick={() => this.updateDrawer(FEATUREKEYS.payroll)}
                    >
                      <ListItemIcon className="list-item-icon">
                        {/* {this.props.selectionReducer.selectedDrawerId ==
                        FEATUREKEYS.payroll ? (
                          <img src={payrollglyph} />
                        ) : (
                          <img src={payrollglyph} />
                        )} */}
                        <img src={payrollglyph} />
                      </ListItemIcon>
                      <ListItemText
                        className="list-item-text"
                        primary="Payroll"
                      />
                    </ListItem>
                  </NavLink>
                )}
                {GetFeature("okr") && GetFeature("employeeokr") && (
                  <NavLink to="/okr">
                    <ListItem
                      button
                      className={
                        this.props.selectionReducer.selectedDrawerId ==
                        FEATUREKEYS.employeeokr
                          ? " nav-list nav-list-item-row-active"
                          : "nav-list"
                      }
                      onClick={() => this.updateDrawer(FEATUREKEYS.employeeokr)}
                    >
                      <ListItemIcon className="list-item-icon">
                        {/* {this.props.selectionReducer.selectedDrawerId ==
                        FEATUREKEYS.employeeokr ? (
                          <img src={okroutlined} />
                        ) : (
                          <img src={okroutlined} />
                        )} */}
                        <img src={okroutlined} />
                      </ListItemIcon>
                      <ListItemText
                        className="list-item-text"
                        primary="OKRs & Goals"
                      />
                    </ListItem>
                  </NavLink>
                )}
                {/* {GetFeature("degree") && GetFeature("zero") && ( */}
                {/* {GetFeature("degree") && ( */}
                {GetFeature("zero") && (
                  <NavLink to="/pendingreviews">
                    <ListItem
                      button
                      className={
                        this.props.selectionReducer.selectedDrawerId ==
                        FEATUREKEYS.zero
                          ? " nav-list nav-list-item-row-active"
                          : "nav-list"
                      }
                      onClick={() => this.updateDrawer(FEATUREKEYS.zero)}
                    >
                      <ListItemIcon className="list-item-icon">
                        {/* {this.props.selectionReducer.selectedDrawerId ==
                        FEATUREKEYS.zero ? (
                          <img src={Performreviewoutlined} />
                        ) : (
                          <img src={Performreviewoutlined} />
                        )} */}
                        <img src={Performreviewoutlined} />
                      </ListItemIcon>
                      <ListItemText
                        className="list-item-text"
                        primary="360° Reviews"
                      />
                    </ListItem>
                  </NavLink>
                )}
                {GetFeature("helpdesk") && GetFeature("helpdeskEmployee") && (
                  <NavLink to="/helpdesk">
                    <ListItem
                      button
                      className={
                        this.props.selectionReducer.selectedDrawerId ==
                        FEATUREKEYS.helpdesk
                          ? " nav-list nav-list-item-row-active"
                          : "nav-list"
                      }
                      onClick={() => this.updateDrawer(FEATUREKEYS.helpdesk)}
                    >
                      <ListItemIcon className="list-item-icon">
                        {/* {this.props.selectionReducer.selectedDrawerId ==
                        FEATUREKEYS.helpdesk ? (
                          <img src={helpIcon} />
                        ) : (
                          <img src={helpIcon} />
                        )} */}
                        <img src={helpIcon} />
                      </ListItemIcon>
                      <ListItemText
                        className="list-item-text"
                        primary="Helpdesk"
                      />
                    </ListItem>
                  </NavLink>
                )}
              </List>
            </div>
          </div>
          <div className={`nav-footer ${navFooter}`}>
            <div className={`clock-in-out ${hideElement}`}>
              {clockintime && clockintime.length % 2 == 0 ? (
                <span className="punch-in">
                  {clockintime && clockintime.length != 0 && (
                    <p className="small-dark-disabled margin-bottom-8">
                      Last clock-out
                    </p>
                  )}

                  <div>
                    <p className="small-dark-secondary floatleft margin-bottom-16">
                      {clockintime && clockintime.length % 2 == 0
                        ? clockintime[clockintime.length - 1] &&
                          moment(
                            clockintime[clockintime.length - 1]
                              .transactiondatetime,
                          ).format("DD-MMM-YYYY")
                        : " "}
                    </p>
                    <p className="small-dark-secondary floatright margin-bottom-16">
                      {clockintime && clockintime.length % 2 == 0
                        ? clockintime[clockintime.length - 1] &&
                          moment(
                            clockintime[clockintime.length - 1]
                              .transactiondatetime,
                          ).format("hh:mm:ss a")
                        : " "}
                    </p>
                  </div>
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    className="btn btn-primary-md-blue"
                    style={{ height: 40, padding: 0 }}
                    disabled={this.props.issaveinprogress}
                    onClick={() => {
                      this.initwebpunch();
                      this.props.setSaveProgress(true);
                      console.log("in-click");
                    }}
                  >
                    <div>
                      <div>Clock-in ⏰</div>
                      {/* <div>
                        {clockintime && clockintime.length % 2 != 0
                          ? clockintime[clockintime.length - 1] &&
                            moment(clockintime[clockintime.length - 1].transactiondatetime).format(
                              "hh:mm:ss a",
                            )
                          : " "}
                      </div> */}
                    </div>
                  </Button>
                </span>
              ) : (
                <span className="punch-out">
                  {clockintime && clockintime.length % 2 != 0 && (
                    <p className="small-dark-disabled margin-bottom-8">
                      Last clock-in
                    </p>
                  )}
                  <div>
                    <p className="small-dark-secondary floatleft margin-bottom-16">
                      {clockintime && clockintime.length % 2 != 0
                        ? clockintime[clockintime.length - 1] &&
                          moment(
                            clockintime[clockintime.length - 1]
                              .transactiondatetime,
                          ).format("DD-MMM-YYYY")
                        : " "}
                    </p>
                    <p className="small-dark-secondary floatright margin-bottom-16">
                      {clockintime && clockintime.length % 2 != 0
                        ? clockintime[clockintime.length - 1] &&
                          moment(
                            clockintime[clockintime.length - 1]
                              .transactiondatetime,
                          ).format("hh:mm:ss a")
                        : " "}
                    </p>
                  </div>
                  <Button
                    variant="contained"
                    color="primary"
                    className="btn btn-primary-md-yellow"
                    size="large"
                    style={{ height: 40, padding: 0 }}
                    disabled={this.props.issaveinprogress}
                    onClick={() => {
                      this.initwebpunch();
                      this.props.setSaveProgress(true);
                      console.log("out-click");
                    }}
                  >
                    <div>
                      <div>Clock-out ⏰</div>
                      {/* <div>
                        {clockintime && clockintime.length % 2 == 0
                          ? clockintime[clockintime.length - 1] &&
                            moment(clockintime[clockintime.length - 1].transactiondatetime).format(
                              "hh:mm:ss a",
                            )
                          : " "}
                      </div> */}
                    </div>
                  </Button>
                </span>
              )}
            </div>
            <List className={`${navFooterList}`}>
              {inviteEmployee && (
                <NavLink
                  to="/invite_new_employee"
                  onClick={() => this.updateDrawer(FEATUREKEYS.inviteEmployee)}
                  className={
                    this.props.selectionReducer.selectedDrawerId ==
                    FEATUREKEYS.inviteEmployee
                      ? "nav-footer-list-item-active"
                      : "nav-footer-list-item"
                  }
                >
                  <ToolTip title="Invite new employee" placement="top">
                    <ListItem
                      button
                      style={{
                        padding: 12,
                        height: "100%",
                      }}
                    >
                      <ListItemIcon className="footer-list-item-icon">
                        <img
                          src={InviteEmoloyeeIcon}
                          className="popper-menu-item-icon"
                        />
                      </ListItemIcon>
                    </ListItem>
                  </ToolTip>
                </NavLink>
              )}
              {/* {requestCenter && (
                <ToolTip title="Request center" placement="top">
                  <ListItem
                    button
                    className={
                      this.props.selectionReducer.selectedDrawerId ==
                      FEATUREKEYS.requestCenter
                        ? "nav-footer-list-item-active"
                        : "nav-footer-list-item"
                    }
                  >
                    <ListItemIcon className="footer-list-item-icon">
                      <NavLink
                        to="/request_center"
                        onClick={() =>
                          this.updateDrawer(FEATUREKEYS.requestCenter)
                        }
                      >
                        <span>
                          <img
                            src={RequestCenterIcon}
                            className="popper-menu-item-icon"
                          />
                        </span>
                      </NavLink>
                    </ListItemIcon>
                  </ListItem>
                </ToolTip>
              )} */}
              {directory && (
                <NavLink
                  to="/directory"
                  onClick={() => this.updateDrawer(FEATUREKEYS.directory)}
                  className={
                    this.props.selectionReducer.selectedDrawerId ==
                    FEATUREKEYS.directory
                      ? "nav-footer-list-item-active"
                      : "nav-footer-list-item"
                  }
                >
                  <ToolTip title="Directory" placement="top">
                    <ListItem
                      button
                      style={{
                        padding: 12,
                        height: "100%",
                      }}
                    >
                      <ListItemIcon className="footer-list-item-icon">
                        <img
                          src={DirectoryIcon}
                          className="popper-menu-item-icon"
                        />
                      </ListItemIcon>
                    </ListItem>
                  </ToolTip>
                </NavLink>
              )}

              {reportingHierarchy && (
                <NavLink
                  to="/reporting_hierarchy"
                  onClick={() =>
                    this.updateDrawer(FEATUREKEYS.reportingHierarchy)
                  }
                  className={
                    this.props.selectionReducer.selectedDrawerId ==
                    FEATUREKEYS.reportingHierarchy
                      ? "nav-footer-list-item-active"
                      : "nav-footer-list-item"
                  }
                >
                  <ToolTip title="Reportee Hierarchy" placement="top">
                    <ListItem
                      button
                      style={{
                        padding: 12,
                        height: "100%",
                      }}
                    >
                      <ListItemIcon className="footer-list-item-icon">
                        <img src={reportee} className="popper-menu-item-icon" />
                      </ListItemIcon>
                    </ListItem>
                  </ToolTip>
                </NavLink>
              )}

              {(plannersubfeature.length > 0 ||
                livedatasubfeature.length > 0) && (
                <NavLink
                  to="/operations"
                  onClick={() => this.updateDrawer(FEATUREKEYS.operations)}
                  className={
                    this.props.selectionReducer.selectedDrawerId ==
                    FEATUREKEYS.operations
                      ? "nav-footer-list-item-active"
                      : "nav-footer-list-item"
                  }
                >
                  <ToolTip title="Operations" placement="top">
                    <ListItem
                      button
                      style={{
                        padding: 12,
                        height: "100%",
                      }}
                    >
                      <ListItemIcon className="footer-list-item-icon">
                        <img
                          src={LiveDataIcon}
                          className="popper-menu-item-icon"
                        />
                      </ListItemIcon>
                    </ListItem>
                  </ToolTip>
                </NavLink>
              )}

              {reportrobo && (
                <NavLink
                  to="/report_robo"
                  onClick={() => this.updateDrawer(FEATUREKEYS.reportRobo)}
                  className={
                    this.props.selectionReducer.selectedDrawerId ==
                    FEATUREKEYS.reportRobo
                      ? "nav-footer-list-item-active"
                      : "nav-footer-list-item"
                  }
                >
                  <ToolTip title="Report robo" placement="top">
                    <ListItem
                      button
                      style={{
                        padding: 12,
                        height: "100%",
                      }}
                    >
                      <ListItemIcon className="footer-list-item-icon">
                        <img src={RoboIcon} className="popper-menu-item-icon" />
                      </ListItemIcon>
                    </ListItem>
                  </ToolTip>
                </NavLink>
              )}

              {/* {alloff && (
                <ToolTip title="More quick features" placement="top">
                  <ListItem
                    button
                    className={
                      this.state.navPopper
                        ? "nav-footer-list-item-active"
                        : "nav-footer-list-item"
                    }
                    onClick={this.showpopper}
                  >
                    <ListItemIcon className="footer-list-item-icon">
                      <span ref={this.handleref}>
                        <img src={MoreIcon} className="popper-menu-item-icon" />
                      </span>
                    </ListItemIcon>
                  </ListItem>
                </ToolTip>
              )} */}
            </List>
          </div>
          {alloff && (
            <Popover
              open={this.state.navPopper}
              anchorEl={this.state.nav_anchor}
              // className="popper-menu-main"
              anchorOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              onClose={this.handleClose}
              modifiers={{
                arrow: {
                  enabled: false,
                  element: this.state.arrowRef,
                },
              }}
            >
              <Paper className="popper-menu-paper">
                {plannersubfeature.length > 0 && (
                  // <NavLink to="/planner">
                  <NavLink to="/operations">
                    <div
                      className={
                        this.props.selectionReducer.selectedDrawerId ==
                        FEATUREKEYS.planner
                          ? "popper-menu-item-active"
                          : "popper-menu-item"
                      }
                      // className="popper-menu-item"
                      onClick={() => this.updateDrawer(FEATUREKEYS.planner)}
                    >
                      <img
                        src={PlannerIcon}
                        className="popper-menu-item-icon"
                      />
                      <span>Planner</span>
                    </div>
                  </NavLink>
                )}
                {livedatasubfeature.length > 0 && (
                  <NavLink to="/live_data">
                    <div
                      className={
                        this.props.selectionReducer.selectedDrawerId ==
                        FEATUREKEYS.livedata
                          ? "popper-menu-item-active"
                          : "popper-menu-item"
                      }
                      onClick={() => this.updateDrawer(FEATUREKEYS.livedata)}
                    >
                      <img
                        src={LiveDataIcon}
                        className="popper-menu-item-icon"
                      />
                      <span>Data</span>
                    </div>
                  </NavLink>
                )}
                {reportrobo && (
                  <NavLink to="/report_robo">
                    <div
                      className={
                        this.props.selectionReducer.selectedDrawerId ==
                        FEATUREKEYS.reportRobo
                          ? "popper-menu-item-active"
                          : "popper-menu-item"
                      }
                      onClick={() => this.updateDrawer(FEATUREKEYS.reportRobo)}
                    >
                      <img src={RoboIcon} className="popper-menu-item-icon" />
                      <span>Robo</span>
                    </div>
                  </NavLink>
                )}
              </Paper>
            </Popover>
          )}
        </div>
      </IntlProvider>
    );
  }
}

const mapStateToProps = (state) => ({
  AuthenticationAction: state.AuthenticationAction,
  SubscriptionInfo: state.SubscriptionInfo,
  selectionReducer: state.selectionReducer,
  FCMReducer: state.FCMReducer,
  issaveinprogress: state.SaveInProgressReducer.issaveinprogress,
  clockin: state.clockinReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      LogMeOut,
      updateAuthentication: (data) => updateAuthentication(data),
      CommonReducerAction: (type, data) => CommonReducerAction(type, data),
      SetSelection,
      SetDrawerID,
      updateSubscriptionInfo: (type, payload) =>
        updateSubscriptionInfo(type, payload),
      SetMenuList,
      SetMenuData,
      SetClickedBreadCrum,
      SetAllApps,
      setSaveProgress,
      removeSaveProgress,
      SetOpenLeftDrawer,
    },
    dispatch,
  );

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withStyles(styles, { withTheme: true })(withSnackbar(LeftNavigation))),
);
